export default "__VITE_ASSET__Cym5D_Gs__"